import { UserAdapters } from '../adapters';
import { UsersApi } from '../clients';
import { InternalUserRoles } from '../clients/GetInternalUsersByRole';

/**
 * The recruiter list, from the auth-service role query, which maintains itself
 * as recruiters join and leave.
 *
 * @returns {Promise<import('../types/User').IGetInternalUsersResult>}
 */
export const getRecruiters = async () => {
  const response = await UsersApi.getInternalUsersByRole(InternalUserRoles.Recruiter);

  return UserAdapters.toGetInternalUsersResult(response);
};
